module.exports = __webpack_public_path__ + "img/light.5d2e5844.svg";